

const VmmWhitepaperPage = () => {
  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
      }}
    >
      <iframe
        title="VMM Whitepaper"
        loading="lazy"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        src="https://www.canva.com/design/DAGtH9GmLUw/Pnv-ly8-itTNqxC_RMU9sw/view?embed"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default VmmWhitepaperPage;